import * as React from "react"
import { Flow, ReportKind } from "@digits-graphql/frontend/graphql-bearer"
import { AgingChartComponent } from "src/frontend/components/Shared/Layout/Components/Charts/AgingChartComponent"
import { type ComponentSize } from "src/frontend/components/Shared/Layout/ComponentSize"
import {
  type MatchedComponent,
  type SizingProps,
} from "src/frontend/components/Shared/Layout/types"
import { useAgingSummaryChartLiveData } from "src/frontend/components/Shared/Portals/hooks/useAgingSummaryChartLiveData"

const getTitle = (componentSize: ComponentSize, kind: ReportKind) => {
  if (componentSize.isExtraLarge || componentSize.isLarge) {
    return kind === ReportKind.APAging
      ? "Accounts Payable Aging Summary"
      : "Accounts Receivable Aging Summary"
  }
  return kind === ReportKind.APAging ? "AP Aging Summary" : "AR Aging Summary"
}

interface AgingSummaryChartComponentProps extends SizingProps {
  component: MatchedComponent<"agingSummaryChart">
  componentSize: ComponentSize
  skipAnimations: boolean
  includeTitleLink?: boolean
}

export const AgingSummaryChartComponent: React.FC<AgingSummaryChartComponentProps> = ({
  component,
  componentSize,
  height,
  skipAnimations,
  includeTitleLink,
}) => {
  const { dimensionalSummary, loading } = useAgingSummaryChartLiveData(
    component.config.agingSummaryChart,
    component.config.type
  )

  return (
    <AgingChartComponent
      dimensionalSummary={dimensionalSummary}
      componentSize={componentSize}
      includeTitleLink={includeTitleLink}
      kind={component.config.agingSummaryChart.kind}
      title={component.title ?? getTitle(componentSize, component.config.agingSummaryChart.kind)}
      loading={loading}
      height={height}
      skipAnimations={skipAnimations}
      flow={
        component.config.agingSummaryChart.kind === ReportKind.APAging
          ? Flow.Outbound
          : Flow.Inbound
      }
    />
  )
}
